import { SystemPageKey } from '@internal/page/SystemPageKey'
import { Locale, TLocale } from '@internal/utils/machine/i18n/Locale'
import { urlFor } from '@internal/utils/routing/urls/urlFor'
import { useRouter } from 'next/router'
import { PageContext } from 'page/PageContext'
import { useContext, useMemo } from 'react'
import { PageTypeKey } from 'utils/page/PageTypeKey'
import { getLocalizedUrlMapForStartPage } from 'utils/routing/urls/getLocalizedUrlMapForStartPage'
import { TLocalizedUrlMap } from './TLocalizedUrlMap'

export const useLocalizedUrlMap = () => {
  const { pageData, localizedUrlMap } = useContext(PageContext)
  const { asPath } = useRouter()

  const localizations = useMemo(() => {
    let map: TLocalizedUrlMap = {
      ...getLocalizedUrlMapForStartPage(),
      ...(localizedUrlMap ?? []),
    }

    if (!pageData) {
      return map
    }

    switch (pageData.type) {
      case PageTypeKey.Page: {
        map = Object.assign({}, map, pageData.localizations)
        break
      }
      case PageTypeKey.SystemPage: {
        if (pageData.key === SystemPageKey.Dashboard) {
          const dashboardRoute = asPath.split('#')[1] || ''

          for (const localeKey of Object.keys(Locale)) {
            const locale = localeKey as TLocale
            map[locale] = urlFor(locale, {
              key: SystemPageKey.Dashboard,
              dashboardRoute,
            })
          }
        }
        break
      }
    }

    return map
  }, [localizedUrlMap, pageData, asPath])

  return localizations
}
